export default __webpack_public_path__ + "static/media/Bhedaghat_jabalpur.c318111e.jpg";